export default "__VITE_ASSET__Cr42ixoG__"